import { useState } from "react";
import { persistPresenceSidebarSlim, readPresenceSidebarSlim } from "../shell/sidebar";
import AureliaCopyright from "./AureliaCopyright";
import { IconAvis, IconFiches, IconPhotos, IconPublish, IconStats } from "./icons";
import ThemeMenu from "./ThemeMenu";

export type Tab = "places" | "reviews" | "photos" | "stats" | "publish";

type Props = {
  tab: Tab;
  onTab: (tab: Tab) => void;
};

const ITEMS: { id: Tab; label: string; hint: string; Icon: typeof IconFiches }[] = [
  { id: "places", label: "Fiches", hint: "Horaires et infos", Icon: IconFiches },
  { id: "reviews", label: "Avis", hint: "Répondre", Icon: IconAvis },
  { id: "photos", label: "Photos", hint: "Galerie", Icon: IconPhotos },
  { id: "stats", label: "Stats", hint: "28 jours", Icon: IconStats },
  { id: "publish", label: "Publier", hint: "Facebook et Instagram", Icon: IconPublish },
];

function IconCollapse({ slim }: { slim: boolean }) {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" aria-hidden>
      {slim ? <path d="M9 6l6 6-6 6" /> : <path d="M15 6l-6 6 6 6" />}
    </svg>
  );
}

export default function WorkspaceNav({ tab, onTab }: Props) {
  const [slim, setSlim] = useState(readPresenceSidebarSlim);

  function toggleSlim() {
    setSlim((prev) => {
      const next = !prev;
      persistPresenceSidebarSlim(next);
      return next;
    });
  }

  return (
    <nav className={`pr-nav${slim ? " is-slim" : ""}`} aria-label="Présence">
      <div className="pr-nav-brand">
        <p>Présence</p>
        <span>Fiches, avis et publications.</span>
      </div>
      <div className="pr-nav-list">
        {ITEMS.map((item) => (
          <button
            key={item.id}
            type="button"
            title={item.label}
            onClick={() => onTab(item.id)}
            className={`pr-nav-btn ${tab === item.id ? "is-on" : ""}`}
          >
            <item.Icon className="pr-nav-ico" />
            <span className="pr-nav-copy">
              <span className="block">{item.label}</span>
              <span className="pr-nav-hint">{item.hint}</span>
            </span>
          </button>
        ))}
      </div>
      <div className="pr-nav-foot">
        <div className="pr-nav-tools">
          <ThemeMenu />
          <button
            type="button"
            className="pr-iconbtn pr-nav-collapse"
            aria-label={slim ? "Déplier le menu" : "Replier le menu"}
            title={slim ? "Déplier" : "Replier"}
            onClick={toggleSlim}
          >
            <IconCollapse slim={slim} />
          </button>
        </div>
        <AureliaCopyright />
      </div>
    </nav>
  );
}
